import {Component, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {AccessRoleSearchPageComponent} from "../access-role-search-page/access-role-search-page.component";

export class AccessRoleReportSelectionData extends EntityData<AccessRoleReportSelectionData> {
    @identifier accessRoleId: number;
    @field name: string;
}

@Component({
    selector: "wbo-access-role-report-selection",
    templateUrl: "./access-role-report-selection-control.component.html"
})
export class AccessRoleReportSelectionControlComponent {

    AccessRoleSearchPageComponent = AccessRoleSearchPageComponent;

    fieldName: string = "accessRoles";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromAccessRole(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((accessRole: any) => accessRole.accessRoleId === item.accessRoleId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
